import { GridColDef } from '@mui/x-data-grid';

import BooleanStatusCell from './components/BooleanStatusCell';
import { formatQcStatusLabel } from './utils';

// eslint-disable-next-line import/prefer-default-export
export const snapshotComparisonColumns: GridColDef[] = [
  {
    field: 'application_number',
    headerName: 'Application Number',
    flex: 1,
    minWidth: 220,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'qc_status',
    headerName: 'QC Status',
    flex: 1,
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: ({ value }) => formatQcStatusLabel(Boolean(value))
  },
  {
    field: 'change_detection_status',
    headerName: 'Changes To Report',
    flex: 1,
    minWidth: 180,
    headerAlign: 'center',
    align: 'center',
    renderCell: ({ value }) => <BooleanStatusCell value={Boolean(value)} />
  }
];
